import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        cardContent: {
            flexGrow: 1,
            [theme.breakpoints.down('xs')]: {
                'width': '100%',
                'padding': theme.spacing(2, 0),
                '@media (orientation: portrait)': {
                    paddingBottom: 51,
                },
            },
        },
    }),
)
